module.exports = __webpack_public_path__ + "img/class-teacher.ce90a498.svg";